import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import CreateDepositPromotionForm from '../CreateDepositPromotionForm'
import NavigateBackButton from '@/common/components/NavigateBackButton'
export default function CreateDepositPromotionListing() {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title={`สร้างรายการโปรโมชั่น`}
					description="สร้างรายการโปรโมชั่น"
				/>
				<NavigateBackButton />
			</div>
			<Separator />
			<CreateDepositPromotionForm />
		</div>
	)
}
